// frontend-web/src/pages/AdminPracticeSet.jsx
import React, { useEffect, useState } from "react";
import api from "../api";

export default function AdminPracticeSet() {
  const [subjects, setSubjects] = useState([]);
  const [name, setName] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [numQuestions, setNumQuestions] = useState(10);
  const [durationSeconds, setDurationSeconds] = useState(1800); // 30 min
  const [loading, setLoading] = useState(false);

  useEffect(()=> {
    api.get("/admin/subjects")
      .then(r=> setSubjects(r.data))
      .catch(()=> setSubjects([]));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!name || !subjectId) { alert("Name and subject required"); return; }
    setLoading(true);
    try {
      await api.post("/admin/practice_set", {
        name, subject_id: parseInt(subjectId), num_questions: parseInt(numQuestions), duration_seconds: parseInt(durationSeconds)
      });
      alert("Practice set created");
      setName(""); setNumQuestions(10); setDurationSeconds(1800);
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.error || "Error creating practice set");
    } finally { setLoading(false); }
  };

  return (
    <div style={{padding:20}}>
      <h2>Create Practice Set</h2>
      <form onSubmit={submit}>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder="Set Name" style={{width:"100%",padding:8,marginBottom:8}} />
        <select value={subjectId} onChange={e=>setSubjectId(e.target.value)} style={{width:"100%",padding:8,marginBottom:8}}>
          <option value="">Select Subject</option>
          {subjects.map(s=> <option key={s.id} value={s.id}>{s.name} (Class {s.class_id})</option>)}
        </select>
        <input type="number" value={numQuestions} onChange={e=>setNumQuestions(e.target.value)} placeholder="No. of Questions" style={{width:"100%",padding:8,marginBottom:8}} />
        <input type="number" value={durationSeconds} onChange={e=>setDurationSeconds(e.target.value)} placeholder="Duration (seconds)" style={{width:"100%",padding:8,marginBottom:8}} />
        <button type="submit" disabled={loading} style={{padding:8}}>{loading? "Creating..." : "Create Practice Set"}</button>
      </form>
    </div>
  );
}
